
import { BeatThemeProvider } from "@evt/beat"
import { Home } from "./pages/Home"

const App = () => (
  <BeatThemeProvider >
    <Home />
  </BeatThemeProvider>
)
export default App